/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelJobClass.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/job-class";

export class AutogenModelJobClass<RowType extends ModelRow> extends Endpoint<RowType, RowJobClassFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowJobClass extends ModelRow<RowJobClassFields> {
	constructor(values?: Partial<RowJobClassFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowJobClassFields {
	company_id: string;
	division_id: string;
	holiday_glid: string;
	id: string;
	overtime_glid: string;
	regular_glid: string;
	sick_glid: string;
	terminal_id: string;
	vacation_glid: string;
	wcomp_max: number;
	wcomp_max_c: string;
	wcomp_max_d: Date;
	wcomp_max_n: number;
	wcomp_max_r: number;
	wcomp_overtime: number;
	wcomp_regular: number;
}

